var map = {
	"./news-11-1.jpg": 87624,
	"./news-11-10.jpg": 31506,
	"./news-11-11.jpg": 91535,
	"./news-11-12.jpg": 17568,
	"./news-11-13.jpg": 69309,
	"./news-11-14.jpg": 62966,
	"./news-11-2.jpg": 21847,
	"./news-11-3.jpg": 27386,
	"./news-11-4.jpg": 29225,
	"./news-11-5.jpg": 67500,
	"./news-11-6.jpg": 10299,
	"./news-11-7.jpg": 39166,
	"./news-11-8.jpg": 60413,
	"./news-11-9.jpg": 4832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63614;